import React, { useEffect } from 'react'
import { Typography } from '@mui/material'

import { UseImage, GenericContainerConfirm } from '../../components'
import { getReplaceTitle } from '../../utils'
import packageJson from "../../../package.json";
import RegistroExitosoImg from '../../assets/RegistroExitoso.jpg'

export default function ConfirmFinalizeComponent(props) {

  useEffect(() => {//ComponentDidUpdate
    getReplaceTitle("Confirmación")
  }, [])

  return (<>
    <UseImage
      src={RegistroExitosoImg}
      type='Image'
      width='100%'
    />
    <GenericContainerConfirm>
      <Typography variant="h6" gutterBottom sx={{width: "100%", textAlign: "center"}} >Cuenta activada correctamente</Typography>
      <Typography variant="subtitle1" gutterBottom >Inicia sesión desde la aplicación móvil para continuar con tu trámite.</Typography>
      <Typography variant="subtitle1" gutterBottom >{packageJson.copyright}</Typography>
    </GenericContainerConfirm>
  </>)
}